import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { LayoutProvider } from "./Context/LayoutContext";
import { ThemeProvider } from "./Context/ThemeProvider";
import ChartProvider from "./Context/chartContext";
import FutureProvider from "./Context/futureContext";
import CommodityProvider from "./Context/commodityContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <LayoutProvider>
    <ChartProvider>
      <FutureProvider>
        <CommodityProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </CommodityProvider>
      </FutureProvider>
    </ChartProvider>
  </LayoutProvider>
  // </React.StrictMode>
);
